module.exports = __webpack_public_path__ + "img/9788926854655.01dbdce1.jpg";